<template>
  <div class="DatePickerTimeHours">
    <div class="hour" v-for="hour in hours" @click="selectHour(hour)">
      {{ hour }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

let props = defineProps([
  "date"
]);

let emit = defineEmits([
  "selectedHour"
]);

let hours = computed(() => {
  return [ 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11 ];
});

function selectHour(hour) {
  emit("selectedHour", hour);
}
</script>

<style scoped>
.DatePickerTimeHours {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.hour {
  padding: 20px;
  text-align: center;
}
.hour:hover {
  border-radius: 10px;
  background: var(--gray-200);
}
</style>